import React, { ReactNode } from "react";
import { Box, SvgIcon, ThemeProvider, Typography, createTheme } from "@mui/material";
import { classNames } from "../../models/models";
import colors from "../../themes/colors";

type TableEmptyProps = {
  iconComponent?: React.ElementType,
  text?: any,
  secondaryText?: any,
  className?: string,
  children?: ReactNode
};

const TableEmpty = ({ iconComponent, text, secondaryText, className, children }: TableEmptyProps) => {
  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Box className={classNames("h-full flex flex-col items-center justify-center", className)}>
        {iconComponent && (
          <SvgIcon component={iconComponent} sx={{ height: 80, width: 120 }} className="mb-3" />
        )}

        <Typography
          fontSize={36}
          lineHeight={1.3}
          fontWeight={500}
          whiteSpace="pre-line"
          textAlign="center"
          className="pb-3 heading-1">
          {text}
        </Typography>

        <Typography
          fontSize={16}
          lineHeight={1.3}
          fontWeight={500}
          color={colors.secondary.gray40}
          whiteSpace="pre-line"
          textAlign="center"
          className="pb-3 heading-1">
          {secondaryText}
        </Typography>

        {children}
      </Box>
    </ThemeProvider>
  );
};

export default TableEmpty;